export default __webpack_public_path__ + "static/media/Mystery.6f9fa95b.svg";